export default {
  changeLoadingStatus(state, payload) {
    state.Loading = payload;
  },

  updateMenuActive(state, payload) {
    state.MenuActive = payload;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },

  updateIsTokenExpired(state, payload) {
    state.IsTokenExpired = payload;
  },

  updateIsExpandSibar(state, payload) {
    state.IsExpandSibar = payload;
  },
};
